module.exports = __webpack_public_path__ + "img/img_left_nav_vip.d9946d31.svg";